module.exports = __webpack_public_path__ + "img/0.c437f119.gif";